module.exports = __webpack_public_path__ + "img/dalou_7_4@2x.0e78ad0f.png";